let pixelReady = false;

export function initPixel(pixelId) {
  if (!pixelId || pixelReady || typeof window === "undefined") return;
  const w = window;
  if (w.fbq) return;
  const n = (w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  });
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
  w.fbq("init", pixelId);
  pixelReady = true;
}

export function trackEvent(name, data) {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", name, data || {});
  }
}
